module.exports = {"410781100":"汲水镇","410781101":"太公镇","410781102":"孙杏村镇","410781103":"后河镇","410781104":"李源屯镇","410781105":"唐庄镇","410781106":"上乐村镇","410781201":"狮豹头乡","410781203":"安都乡","410781204":"顿坊店乡","410781205":"柳庄乡","410781206":"庞寨乡","410781208":"城郊乡","410781400":"卫辉市高效农业服务中心","410781401":"东风农场","410781402":"苗圃场","410781403":"农科所","410781404":"五四农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410781.json
// module id = 1716
// module chunks = 0